let Main = {
    onload: document.addEventListener('DOMContentLoaded', function () {
        Main.init();
    }),

    init: function () {
        this.bind();
    },

    bind: function () {
        $(document).on('click', '.services-select__btn', function (e) {
            $(this).toggleClass('active');
            $('.services-select__items').slideToggle('slow');
        }).on('click', '.services-select__item', function (e) {
            $(this).toggleClass('active');
            $('.services-select__items').hide();

            let value = $(this).text().trim();
            let parrent = $(this).closest('.pop-up-form__input');
            parrent.find('.services-select__btn').text(value);
            parrent.find('[name="service"]').val(value);
        }).on('click', '.pop-up__close', function (e) {
            $('.pop-up-block').hide();
        }).on('click', '.contact-popup', function (e) {
            $('.pop-up-block').show();
        }).on('click', '.service-items__btn', function (e) {
            $('.pop-up-block').show();
        }).on('click', '.banner-product__btn', function (e) {
            $('.pop-up-block').show();
        }).on('click', '.cookies-pop-up__close', function (e) {
            $('.pop-up-block').hide();
        }).on('click', '.menu__item', function (e) {
            // $('.pop-up-block').hide();
            // $('.toggle-menu').click();
        }).on('click', '.scroll', function (e) {
            let block = $(this).attr('href');
            if (block !== undefined && block !== '') {
                $('html').animate({
                    scrollTop: $(block).offset().top - 30
                }, 1000);
            }

            const isMobile = window.matchMedia('(max-width: 768px)').matches;

            if (isMobile) {
                $('.toggle-menu').click();
            }

            return false;
        }).on('click', '.faq__category__items-header', function (e) {
            e.preventDefault();

            $('.faq__category__items-content').hide();
            $(this).next().show();
        });

        $('.toggle-menu').on('click', function () {
            $(this).toggleClass('active');
            // $('.header__wrapper').toggle('slideUp');
            $('.header__wrapper').toggleClass('active');

            $('.header').css('position', $(this).hasClass('active') ? 'fixed' : 'unset');

            $('body').toggleClass('body-hidden');
        });

        const swiperSlide = new Swiper('.swiper', {
            // direction: 'vertical',
            // loop: false,
            pagination: {
                el: '.swiper-pagination',
            },

            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

        $('.form-contact__input input').on('change', function () {
            if ($(this).val().length >= 1) {
                $(this).closest('.form-contact__input').find('span').css('top', "-17px")
                $(this).closest('.form-contact__input').find('span').css('background', "#FBFAFA")
            } else {
                $(this).closest('.form-contact__input').find('span').css('top', "20px")
                $(this).closest('.form-contact__input').find('span').css('background', "inherit")
            }
        });

        $('.form-contact__input textarea').on('change', function () {
            if ($(this).val().length >= 1) {
                $(this).closest('.form-contact__input').find('span').css('top', "-17px")
                $(this).closest('.form-contact__input').find('span').css('background', "#FBFAFA")
            } else {
                $(this).closest('.form-contact__input').find('span').css('top', "20px")
                $(this).closest('.form-contact__input').find('span').css('background', "inherit")
            }
        });

        $('.pop-up-form__input input').on('change', function () {
            if ($(this).val().length >= 1) {
                $(this).closest('.pop-up-form__input').find('span').css('top', "-17px")
                $(this).closest('.pop-up-form__input').find('span').css('background', "#FBFAFA")
            } else {
                $(this).closest('.pop-up-form__input').find('span').css('top', "20px")
                $(this).closest('.pop-up-form__input').find('span').css('background', "inherit")
            }
        });

        $('.pop-up-form__textarea textarea').on('change', function () {
            if ($(this).val().length >= 1) {
                $(this).closest('.pop-up-form__textarea').find('span').css('top', "-17px")
                $(this).closest('.pop-up-form__textarea').find('span').css('background', "#FBFAFA")
            } else {
                $(this).closest('.pop-up-form__textarea').find('span').css('top', "20px")
                $(this).closest('.pop-up-form__textarea').find('span').css('background', "inherit")
            }
        });
    },

    // ajax: {
    //     obj: {},
    //     url: AJAX_URL,
    //     send: function (success, failure) {
    //         $.post(this.url, this.obj, (answer) => {
    //             this.obj = {};
    //             answer.result && typeof success === 'function' ? success(answer) :
    //                 !answer.result && typeof failure === 'function' ? failure(answer) : null;
    //         }, 'JSON');
    //     },

    // ex: function () {
    //     this.obj.method = 'ex';
    //     this.obj.typeID = type;
    //     this.send(function (answer) {
    //
    //     }, (answer) => { });
    // },
}